export const CHANGELOG_PATH = "/changelog";

type VersionBadgeProps = {
  version: string;
  changelogUrl?: string;
};

export const VersionBadge = ({
  version,
  changelogUrl = CHANGELOG_PATH,
}: VersionBadgeProps) => (
  <a
    href={changelogUrl}
    target="_blank"
    rel="noreferrer"
    className="fixed bottom-2 right-2 z-[9999] rounded-full bg-black/70 px-2.5 py-1 font-mono text-[11px] leading-none text-white no-underline transition-colors hover:bg-black/90"
  >
    v{version} · changelog
  </a>
);
